<span [class]="iconClasses"></span>